import { inject, Injectable } from '@angular/core';
import { SelectedApexMech, ViewStateType } from '@ortho-next/nextray-core';
import { bindedModel } from '../../nextray/Models/BindedModel';
import { AnatomicalSideEnum } from '../core';
import { BaseHelpService } from './base-help.service';
import { CanvasService } from './canvas.service';


/**
* This service handles help modal.
*/
@Injectable({ providedIn: 'root' })
export class HelpService extends BaseHelpService {

	private readonly canvasSrv = inject(CanvasService);


	override get fileKey(): string {
		if (this.canvasSrv.isStrokeLocked) { //Before Insertion
			return `STROKE_${this.boneType}_${this.side}_${this.activeView}_${this.insApproach}`;
		}
		else if (this.canvasSrv.isFitboneInserted) { // FitBone Selection Completed
			return `FITBONE_${this.boneType}_${this.side}_${this.activeView}_${this.insApproach}`;
		}
		else if (this.canvasSrv.isEocCut) { // CUT completed
			return `CUT_${this.boneType}_${this.side}_${this.activeView}_${this.insApproach}`;
		}
		else if (this.canvasSrv.isInsPointInserted && !bindedModel.isInsertionPointEnabled) { // Insertion Completed
			return `INSERTION_${this.boneType}_${this.side}_${this.activeView}_${this.insApproach}`;
		} else { // Before Insertion
			return `BEFORE_${this.boneType}_${this.side}_${this.activeView}`;
		}
	}

	private get boneType(): string {
		return 'LONGLEG';
	}

	private get side(): string {
		if (!this.canvasSrv.currentCase) return '';
		switch (this.canvasSrv.currentCase.side) {
			case AnatomicalSideEnum.Left: return 'LEFT';
			case AnatomicalSideEnum.Right: return 'RIGHT';
			default: return '';
		}
	}

	private get activeView(): string {
		switch (this.canvasSrv.activeViewState) {
			case ViewStateType.AP: return 'AP';
			case ViewStateType.LT: return 'LAT';
			case ViewStateType.multiple: return 'MUL';
			default: return '';
		}
	}

	private get insApproach(): string {
		switch (this.canvasSrv.selectedApex) {
			case SelectedApexMech.femurProximal: return 'ANTEGRADE_FEMUR'
			case SelectedApexMech.femurDistal: return 'RETROGRADE_FEMUR';
			case SelectedApexMech.tibiaProximal: return 'ANTEGRADE_TIBIA';
			default: return '';
		}
	}

}
